export const KeyCodeConstants = {
  RIGHT_ARROW: 39,
  LEFT_ARROW: 37,
  DOWN_ARROW: 40,
  UP_ARROW: 38,
  ENTER: 13,
  TAB: 9,
  SPACE: 32,
  ESC: 27,
};

export default KeyCodeConstants;
